import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import { createProvider } from './vue-apollo'
import axios from "axios";
import firebase from "firebase/app";
import 'regenerator-runtime/runtime'

Vue.prototype.$axios = axios;
Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: "AIzaSyCHX77LpP_TrC2PzLZM-6S1qp1i5FzWrms",
  authDomain: "electric-icon-247618.firebaseapp.com",
  databaseURL: "https://electric-icon-247618.firebaseio.com",
  projectId: "electric-icon-247618",
  storageBucket: "electric-icon-247618.appspot.com",
  messagingSenderId: "1094922447836",
  appId: "1:1094922447836:web:fe92428b3bfe79bf53fd19"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

let app;
firebase.auth().onAuthStateChanged(user => {
  console.log("user", user);
  if (!app) {
    new Vue({
      router,
      vuetify,
      apolloProvider: createProvider(),
      render: h => h(App)
    }).$mount('#app');
  }
});